import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import Profile from "../components/Profile";
import Security from "../components/Security";
import Notification from "../components/Notification";

// Tabs names
const tabs = ["Account", "Security", "Notification"];

// Content for each tab
const tabContents  = (setActiveTab) => ({
  "Account": <Profile active="Profile" />,
  "Security": <Security setActiveTab={setActiveTab}/>,
  "Notification": <Notification active="Notification" />,
});



const Settings = () => {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("Account");

  const navigate = useNavigate();
  

  return (
    <div>
      <div className="md:p-10 pb-4 p-4 text-base gap-4 w-full">
        {/* Page Titles */}
        <h1 className="text-2xl font-bold mb-2 dark:text-gray-200">Account & Settings</h1>
        <p className="text-gray-600 pb-6 text-sm flex flex-wrap gap-1 items-center dark:text-gray-400">
        <Link to="/dashboard" className="hover:underline ">
            Dashboard
        </Link>{" "}
        /{" "}
        {activeTab ? <span className="agarly-gradient-text font-bold"> {activeTab}</span> : ""}
        </p>

        <div className="flex flex-col rounded-2xl md:p-0 p-2 bg-gray-50  gap-6 dark:bg-black">
          
          {/* Tabs */}
        <div className="flex py-[5px] px-[5px] font-bold md:space-x-4 border-2 py-2 px-2 border-gray-300 rounded-xl justify-between dark:bg-[#1A1A1B] dark:border-[#3D3D3D] ">
          {tabs.map((tab) => (
            <button
              key={tab}
              className={`px-4 py-2 md:px-[150px] text-sm rounded-lg ${
                activeTab === tab
                ? "bg-blue-100 text-gray-600"
                : "text-gray-600 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-[#2D2D2D]"
            }`}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </button>
          ))}
        </div>


        {/* Tab Content */}
        <div>
          {activeTab ? tabContents(setActiveTab)[activeTab] : "Please select a tab"}
        </div>
      </div>
      </div>
    </div>
  );
};

export default Settings;
